import { render, staticRenderFns } from "./ConfirmTakeGlass.vue?vue&type=template&id=bc1d9a64&"
import script from "./ConfirmTakeGlass.vue?vue&type=script&lang=ts&"
export * from "./ConfirmTakeGlass.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports